import { PayloadGroupMockup, PersonStatusFieldName } from '../../../../../../../components/Forms/constants';
import { fieldNamesForServerFactory } from '../../../../../../../helpers/fieldNamesForServerFactory';

const payloadGroupName = 'personal_status';

export const personStatusDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadGroupName> = {
  [payloadGroupName]: {
    id: null,
    name: null,
  },
};

export const personStatusDataDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadGroupName,
  fields: [
    {
      localFieldName: PersonStatusFieldName.personStatusName,
      serverFieldName: 'personalStatus',
    },
  ],
});
